import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import f from "./filePreview.ce.vue.js";
import { vCopyVueucStylesToShadowDom as n } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as s, useTemplateRef as c, withDirectives as d, openBlock as u, createBlock as C, withCtx as i, createVNode as a } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as _ } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import v from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import h from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const z = /* @__PURE__ */ s({
  name: "FilePreviewEntry",
  __name: "index.ce",
  setup(P, { expose: l }) {
    const o = _(), t = c("filePreviewRef"), p = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    };
    return l({ open: (m) => {
      var r;
      (r = t.value) == null || r.open(m);
    } }), (m, r) => d((u(), C(e(y), {
      locale: e(v),
      "date-locale": e(h),
      "theme-overrides": p,
      "style-mount-target": e(o)
    }, {
      default: i(() => [
        a(e(w), { to: e(o) }, {
          default: i(() => [
            a(f, {
              ref_key: "filePreviewRef",
              ref: t
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [e(n), e(o)]
    ]);
  }
});
export {
  z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/file-preview/index.ce.vue2.js
// module id = 1240
// module chunks = 41